export const FILE_SOURCE_TYPE = {
  1: 'aiChatConstants.fileSourceType.userUpload',
  2: 'aiChatConstants.fileSourceType.userCreate',
  3: 'aiChatConstants.fileSourceType.summary', //AI会记
  4: 'aiChatConstants.fileSourceType.aiJinbao',
  5: 'aiChatConstants.fileSourceType.meetingSummary', // 会议纪要
  7: 'aiChatConstants.fileSourceType.translate',
  8: 'aiChatConstants.fileSourceType.note',
  9: 'aiChatConstants.fileSourceType.transcribe',
  99: 'aiChatConstants.fileSourceType.other'
};

export const DOCUMENT_BELONG_ENUM = {
  1: '我的文档',
  2: '我的纪要',
  3: '共享知识库',

  MY_DOCUMENT: 1,
  MY_SUMMARY: 2,
  KNOWLEDGE: 3
};

// ai进宝对话转码码
export const AI_CHAT_CODE = {
  // 0:生成中/ 1:生成成功（过程中）/ 2:生成失败/ 3:生成完成（已结束）/ 4:生成过程中失败/ 5:生成过程中超时
  // 未开始
  NOT_STARTED: 0,
  // 生成中
  IN_PROGRESS: 1,
  // 生成失败
  FAILED: 2,
  // 已完成
  COMPLETED: 3,
  // 生成过程中失败
  IN_PROGRESS_FAILED: 4,
  // 生成过程中超时
  IN_PROGRESS_TIMEOUT: 5,

  0: '未开始',
  1: '生成中',
  2: '生成失败',
  3: '已完成',
  4: '生成过程中失败',
  5: '生成过程中超时'
};

// AI进宝 深度研究状态
export const AI_CHAT_RESEARCH_STATUS = {
  START: '',
  THINKING: '正在思考',
  SEARCH: '正在搜索',
  TOOL_CALL: '正在调用工具',
  END: '已完成'
};

// Ai进宝 深度研究 内容类型
export const AI_CHAT_RESEARCH_CONTENT_TYPE = {
  TITLE: 'title', // 标题
  DOCUMENT: 'document', // 文档
  THINKING: 'thinking', // 深度思考
  TOOL: 'tool', // 工具调用
  MESSAGE: 'message', // 消息,
  FINAL_TOOL: 'finalTool', // 最终工具生成,
  QUOTE: 'quote', // 引用资料
  SKILL: 'skill' // 投研大脑思维链调用
};

// 进宝来源类型
export const AI_CHAT_SOURCE_TYPE = {
  // 进宝
  AI_CHAT: 1,
  // 路演
  ROADSHOW: 2,
  // 纪要
  SUMMARY: 3,
  // 研报
  RESEARCH: 4,
  // 外资研报
  FOREIGN_RESEARCH: 5,
  // 全局搜索
  GLOBAL_SEARCH: 6,
  /** 自选 */
  SELF_SELECTED: 7,
  // AI进宝研究模式
  RESEARCH_MODE: 9,
  // 云文档
  CLOUD_DOC: 10,

  1: 'AI进宝',
  2: '路演厅',
  3: '纪要详情页',
  4: '研报详情页',
  5: '外资研报',
  6: '全局搜索',
  7: '自选',
  9: 'AI进宝研究模式',
  10: '云文档'
};

// 直接在当前页面查看历史会话的 进宝来源类型
export const VIEW_SOURCE_TYPES = [
  AI_CHAT_SOURCE_TYPE.AI_CHAT,
  AI_CHAT_SOURCE_TYPE.GLOBAL_SEARCH,
  AI_CHAT_SOURCE_TYPE.SELF_SELECTED
];

// 纪要详情页 研报详情页相关的页面禁用模型对照 与 AI_CHAT_MODE 的label统一
export const DISABLE_MODEL_MAP = {
  [AI_CHAT_SOURCE_TYPE.AI_CHAT]: [],
  [AI_CHAT_SOURCE_TYPE.ROADSHOW]: [],
  [AI_CHAT_SOURCE_TYPE.SUMMARY]: ['深度研究', 'Agent模式', 'MCP模式'],
  [AI_CHAT_SOURCE_TYPE.RESEARCH]: ['深度研究', 'Agent模式', 'MCP模式'],
  [AI_CHAT_SOURCE_TYPE.FOREIGN_RESEARCH]: ['深度研究', 'Agent模式', 'MCP模式'],
  [AI_CHAT_SOURCE_TYPE.RESEARCH_MODE]: [],
  [AI_CHAT_SOURCE_TYPE.CLOUD_DOC]: ['深度研究', 'Agent模式', 'MCP模式']
};

// 模型列表icon
export const MODEL_LIST_ICON = {
  DEEPSEEK: 'DEEPSEEK',
  'QWEN-3': 'QWEN-3',
  HUNYUAN: 'HUNYUAN',
  KIMI: 'KIMI',
  QWEN: 'QWEN-3',
  DOUBAO: 'DOUBAO'
};

// 智能体 icon 颜色，按照使用顺序进行排列
export const AGENT_COLOR_SORTED_LIST = ['#3964E5', '#F07146', '#8F39E5', '#E5398F', '#00B9C3', '#E53939'];

// 深度研究-计划状态
export const DEEP_RESEARCH_PLAN_STATUS = {
  ABANDONED: -1,
  PENDING: 0,
  EXECUTED: 1,
  NULL: 99,

  '-1': '已废弃',
  0: '待执行',
  1: '已执行',
  99: '未知'
};

// 智能体状态
export const AGENT_STATUS = {
  // 未开始
  NOT_STARTED: 1,
  // 进行中
  IN_PROGRESS: 2,
  // BETA
  BETA: 3,
  // 已完成
  COMPLETED: 3
};

// 消息列表是否已读
export const IS_READ = {
  // 未读
  NOT_READ: 0,
  // 已读
  READ: 1
};

// 是否正在会话中
export const IS_IN_SESSION = {
  // 进行中
  IN_PROGRESS: 1,
  // 已完成
  COMPLETED: 2
};

// 子智能体类型
export const SUB_AGENT_TYPE = {
  // 卖方深度研究报告
  SELLER_DEEP_RESEARCH_REPORT: 'seller_deep_research_report',
  // 生成行业深度报告
  GENERATE_INDUSTRY_DEPTH_REPORT: 'generate_industry_depth_report',
  //生成公司简报
  GENERATE_COMPANY_BRIEF_REPORT: 'generate_company_brief_report'
};

// 用户身份类型
export const USER_IDENTITY_TYPE = {
  // 卖方
  SELL_SIDE: 'sell_side'
  // 行业研究员
  // INDUSTRY_ANALYST: 'industry_analyst'
};

// 用户身份与子智能体类型的映射关系
export const USER_IDENTITY_TO_SUB_AGENT_MAP = {
  // [USER_IDENTITY_TYPE.BUY_SIDE]: SUB_AGENT_TYPE.SELLER_DEEP_RESEARCH_REPORT,
  [USER_IDENTITY_TYPE.SELL_SIDE]: SUB_AGENT_TYPE.SELLER_DEEP_RESEARCH_REPORT
  // [USER_IDENTITY_TYPE.INDUSTRY_ANALYST]: SUB_AGENT_TYPE.GENERATE_INDUSTRY_DEPTH_REPORT
  // [USER_IDENTITY_TYPE.LISTED_COMPANY]: SUB_AGENT_TYPE.SELLER_DEEP_RESEARCH_REPORT
};

// 召回资料引用类型
export const REFERENCE_TYPE = {
  DOC: 'doc',
  CHUNK: 'chunk'
};

// 智能体类型，只列举了部分
export const AGENT_TYPE = {
  // 财务查询
  FINANCIAL_SEARCH: 'financial_search',
  // 可比公司
  COMPANY_COMPARE: 'company_compare',
  // 走势复盘
  STOCK_REVIEW: 'stock_review',
  // 深度研究
  DEEP_RESEARCH: 'deep_research',
  // 搜图表
  CHART_SEARCH: 'chart_search',
  // 公司概览
  COMPANY_OVERVIEW: 'company_overview',
  // 行业概览
  INDUSTRY_OVERVIEW: 'industry_overview',
  // 相对估值
  RELATIVE_VALUATION: 'relative_valuation',
  // 业绩回顾
  PERFORMANCE_REVIEW: 'performance_review',
  // 观点对比
  VIEWPOINT_COMPARE: 'viewpoint_compare'
};

// 不显示目录的智能体
export const HIDE_CATALOGUE_AGENT_TYPE_LIST = [
  AGENT_TYPE.FINANCIAL_SEARCH,
  AGENT_TYPE.COMPANY_COMPARE,
  AGENT_TYPE.STOCK_REVIEW,
  AGENT_TYPE.DEEP_RESEARCH,
  AGENT_TYPE.CHART_SEARCH,
  AGENT_TYPE.INDUSTRY_OVERVIEW
];
// 路演文件同步状态
export const ROADSHOW_FILE_EMBEDDING_STATUS = {
  PROCESSING: 0,
  SUCCESSED: 1,
  FAILED: 2,
  EMPTY_CONTENT: 3,

  0: '同步中',
  1: '同步成功',
  2: '同步失败',
  3: '文件为空'
};

// 上传文件状态
export const UPLOAD_FILE_STATE = {
  UPLOADING: 0,
  PROCESSING: 1,
  SUCCESS: 2,
  FAILED: -1
};

// aichat 上传文件类型
export const UPLOAD_DOC_TYPE = {
  // 普通文件
  NORMAL: 0,
  // 云文档
  CLOUD_DOC: 1,
  // 要点文档讲解
  POINTS_DOC_EXPLAIN: 2,
  // 内资研报
  RESEARCH: 3,
  // 外资研报
  FOREIGN_REPORT: 4,
  // 点评
  COMMENT: 5,
  // 纪要
  SUMMARY: 6,
  // 链接
  URL_LINK: 7,
  // 第三方纪要
  THIRD_SUMMARY: 8,
  // 文本
  TEXT: 9,
  0: '本地文件',
  1: '云文档',
  2: '要点文档讲解',
  3: '研报',
  4: '外资研报',
  5: '点评',
  6: '纪要',
  7: '外部链接',
  8: '纪要',
  9: '文本'
};

// AI进宝 研究模式类型
export const AI_CHAT_TYPE = {
  JINBAO: 'jinbao',
  RESEARCH: 'research'
};

// 第三方渠道类型
export const THIRD_CHANNEL_TYPE = {
  // 飞书
  LARK: 1,
  // 企业微信
  WXWORK: 2,
  // QQ
  QQ: 3,
  // 钉钉
  DINGTALK: 4,
  // 微信
  WECHAT: 5,
  // 邮件
  EMAIL: 6,
  1: '飞书',
  2: '企业微信',
  3: 'QQ',
  4: '钉钉',
  5: '微信',
  6: '邮件'
};
